import { useEffect } from "react";

export const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="privacy-policy-page">
      {/* Header */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <p className="text-[0.625rem] tracking-[0.3em] uppercase text-[#D4AF37]/80 mb-4">
              Legal
            </p>
            <h1 className="text-3xl md:text-5xl tracking-[0.02em] text-white/90 mb-6" style={{ fontFamily: 'Cinzel, serif' }}>
              Privacy Policy
            </h1>
            <p className="text-white/40 text-sm">
              Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="pb-24">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto prose prose-invert prose-gold">
            <div className="space-y-8 text-white/70 font-light leading-relaxed">
              
              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>1. Introduction</h2>
                <p>
                  Goldnote Corporation ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. This privacy policy explains how we collect, use, disclose, and safeguard your information when you visit our website or purchase our products.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>2. Information We Collect</h2>
                <p className="mb-4">We may collect information about you in a variety of ways, including:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong className="text-white/90">Personal Data:</strong> Name, email address, phone number, shipping address, billing address, and payment information.</li>
                  <li><strong className="text-white/90">Transaction Data:</strong> Details about purchases and orders you have made.</li>
                  <li><strong className="text-white/90">Technical Data:</strong> IP address, browser type, device information, and browsing patterns.</li>
                  <li><strong className="text-white/90">Marketing Data:</strong> Your preferences for receiving marketing communications.</li>
                </ul>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>3. How We Use Your Information</h2>
                <p className="mb-4">We use the information we collect to:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Process and fulfill your orders</li>
                  <li>Communicate with you about your orders and provide customer support</li>
                  <li>Send promotional communications (with your consent)</li>
                  <li>Improve our website and products</li>
                  <li>Comply with legal obligations</li>
                  <li>Prevent fraud and enhance security</li>
                </ul>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>4. Information Sharing</h2>
                <p>
                  We do not sell your personal information. We may share your data with trusted third parties who assist us in operating our website, conducting our business, or servicing you, including payment processors, shipping carriers, and marketing service providers. These parties are obligated to keep your information confidential.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>5. Data Security</h2>
                <p>
                  We implement appropriate technical and organizational security measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. All payment transactions are encrypted using SSL technology.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>6. Your Rights</h2>
                <p className="mb-4">Depending on your location, you may have the right to:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Access the personal data we hold about you</li>
                  <li>Request correction of inaccurate data</li>
                  <li>Request deletion of your data</li>
                  <li>Object to processing of your data</li>
                  <li>Request data portability</li>
                  <li>Withdraw consent at any time</li>
                </ul>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>7. Cookies</h2>
                <p>
                  We use cookies and similar tracking technologies to enhance your browsing experience. For more information, please see our Cookie Policy.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>8. Contact Us</h2>
                <p>
                  If you have questions about this Privacy Policy or wish to exercise your rights, please contact us at:
                </p>
                <p className="mt-4">
                  <strong className="text-[#D4AF37]">Goldnote Corporation</strong><br />
                  Email: privacy@goldnote.com<br />
                  Phone: 1-800-GOLDNOTE
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
